/**
 * Csv Schema of ResponsavelGrupoEconomico
 * @author Simpli CLI generator
 */
import {Helper, Schema, FieldSet} from 'simpli-web-sdk'
import {ResponsavelGrupoEconomico} from '@/model/resource/ResponsavelGrupoEconomico'

export class CsvResponsavelGrupoEconomicoSchema extends Schema {
  readonly name = 'CsvResponsavelGrupoEconomico'

  readonly fieldSet: FieldSet<ResponsavelGrupoEconomico> = {
    responsavelMaster: schema => schema.model.responsavelMaster?.$id ?? null,
    responsavelPermitido: schema =>
      schema.model.responsavelPermitido?.$id ?? null,
    dataCriacao: schema => Helper.datetime(schema.model.dataCriacao),
  }
}
